import { GetStaticProps } from 'next'
import { getAcademyHomepageContent } from '@/graphql/HealthAcademyHomepage'
import {
  latestArticlesByCategory,
  getTopAcademyCategories,
  getFeaturedArticles,
} from '@/graphql/HealthAcademyCategories'
import { AcademyHomePage } from '@/components/pages/learn/AcademyHomePage'

export const getStaticProps: GetStaticProps = async () => {
  const homepage = await getAcademyHomepageContent()
  const categories = await getTopAcademyCategories()
  const promiseArray = categories.map((category) => latestArticlesByCategory(category.id))
  const articlesByCategory = await Promise.all(promiseArray).then((values) => values)
  const featuredArticles = await getFeaturedArticles()
  return { props: { homepage, categories, articlesByCategory, featuredArticles } }
}

export default AcademyHomePage
